"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAd = getAd;
async function getAd(advertisingRepo, adId) {
    return advertisingRepo.getAd(adId);
}
